import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { Data2Service } from '../../common/data2.service';

@Component({
	selector: 'app-offers-parms',
	templateUrl: './offers-parms.component.html',
	styleUrls: ['./offers-parms.component.css'],
})
export class OffersParmsComponent implements OnInit {
	pageTitle = 'Oferta...';
	loader = false;
	private itemsBeforeDataLoad = 4;
	offer = {
		id: this.route.snapshot.params['id'],
		code: null,
		name: null,
		queryRoom: null,
		queryPriceList: null,
		queryPriceListAverage: null,
		owner: null,
		costsFixed: null,
		costsFixedCurrency: null,
		costsVariable: null,
		costsVariableCurrency: null,
		programFees: null,
		programFeesCurrency: null,
		programFeesType: null,
		plannedPayments: null,
		plannedPaymentsCurrency: null,
		plannedPaymentsType: null,
		deltaAccommodation: null,
		deltaEviction: null,
		poznanFromHour: null,
		poznanFromDays: null,
		poznanToHour: null,
		poznanToDays: null,
		programBeginHour: null,
		programEndHour: null,
		status: null,
	};
	countToStatistic: Array<any> = [
		{ idCount: 0, name: '' },
		{ idCount: '1', name: 'NIE' },
		{ idCount: '2', name: 'TAK' },
	];
	rooms: Array<any> = [];
	priceLists: Array<any> = [];
	users: Array<any> = [];
	currencies: Array<any> = [];
	private readonly originalValues = {
		queryRoom: null,
		queryPriceList: null,
	};

	constructor(
		private readonly api: Data2Service,
		private readonly route: ActivatedRoute,
		private readonly router: Router,
		private readonly infobox: InfoboxService,
	) {}

	ngOnInit(): void {
		this.loader = true;
		this.api.get('/istourOffersRooms?offer=' + this.offer.id, (result, error) => {
			this.rooms = result.data;
			this.loadData();
		});
		this.api.get('/istourOffersPriceLists?offer=' + this.offer.id, (result, error) => {
			this.priceLists = result.data;
			this.loadData();
		});
		this.api.get('/users', (result, error) => {
			this.users = result.data;
			this.loadData();
		});
		this.api.get('/currency', (result, error) => {
			this.currencies = result.data;
			this.loadData();
		});
	}

	private loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.api.get('/istourOffers/' + this.offer.id, (result, error) => {
			this.offer = result.data;
			this.pageTitle = 'Oferta: ' + this.offer.name;
			this.loader = false;
			this.originalValues.queryRoom = this.offer.queryRoom;
			this.originalValues.queryPriceList = this.offer.queryPriceList;
		});
	}

	save(item) {
		const data = {
			cmd: 'update',
			id: item.id,
			name: item.name,
			countToStatistic: item.countToStatistic,
			offerId: this.offer.id,
		};
		this.api.command('/istourOffersPriceLists/', data, (result, error) => {
			if (error) {
				return;
			}
		});
	}

	submit(refreshTerms = 0) {
		if (
			this.offer.queryRoom != this.originalValues.queryRoom ||
			this.offer.queryPriceList != this.originalValues.queryPriceList
		) {
			this.offer.status = '1';
		}
		this.loader = true;
		// this.api.put(
		// 	'/istourOffersTerms/' + this.offer.id,
		// 	this.offer,
		// 	(result, error) => {
		// 		if (error) {
		// 			// alert('error - check console');
		// 			return;
		// 		}
		// 	}
		// );

		const data = {
			cmd: 'update',
			offerId: this.offer.id,
		};

		this.api.put(
			'/istourOffers/' + this.offer.id + '/?refreshTerms=' + refreshTerms,
			this.offer,
			(result, error) => {
				this.loader = false;
				if (error) {
					alert('error - check console');
					return;
				}
				this.api.command('/istourOffersTerms/', data, (result, error) => {
					if (error) {
						return;
					}
					this.loadData();
				});
			},
		);
	}
}
